<template>
    <div>
        <transition name="slide-right-panel">
            <div class="side-panel right-sidebar shw-rside" v-if="show" style="background-color: #f1f5f7">
                <div class="rpanel-title" style="background-color: #FFF; font-weight: 500;">
                    {{ title }} <span><i class="icon mdi mdi-close right-side-toggle"
                                         @click="closeQuotesAndInvoicesPanel"></i></span>
                </div>
                <div>
                    <div>
                        <div class="flex flex-column space-y-2 mx-2 px-1 mt-2 pt-0">
                            <div class="flex items-center w-full justify-center p-4">
                                <secondary-button @click.prevent="createNew">
                                    New Quote / Invoice
                                </secondary-button>
                            </div>

                            <div
                                class="h-full max-h-screen overscroll-none overflow-y-auto scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-indigo-100 px-2 pt-4 pb-64">

                                <div v-for="record in quotesInvoices" class="bg-white rounded p-3 mb-3 mx-2 cursor-pointer shadow-sm"
                                     @click.prevent="showQuoteInvoiceForm(record)">
                                    <div class="flex justify-between items-center">
                                        <h6 class="mb-1 font-medium cursor-pointer">{{ record.type | titlecase }}</h6>
                                        <span class="text-xs font-medium bg-indigo-100 px-2 py-1 rounded text-indigo-600"
                                              style="line-height: 12px">{{ record.status | titlecase }}</span>
                                    </div>

                                    <div
                                        class="flex justify-between items-center py-1 my-2 font-medium bg-gray-100 text-gray-800 rounded px-2">
                                        <span class="m-0">{{ record.reference }}</span><span
                                        class="m-0">{{ app.state.currentTeam.currency }} {{ record.total_incl }}</span>
                                    </div>

                                    <div class="flex justify-between items-center my-1">
                                        <span class="mb-0">{{ record.contact ? record.contact.full_name : "No Contact Selected" }}</span>
                                        <span class="small font-medium mb-0 text-indigo-600">{{ record.date }}</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <quote-invoice ref="quoteInvoiceForm"
                       :contactable="contactable"
                       :contactable-id="contactableId"
                       :issue-options="ticketIssues"
                       :company-charges-vat="companyChargesVat"
                       :auto-calculate-vat="autoCalculateVat"
                       :company-vat-percentage="companyVatPercentage"
                       :vat-calculation="vatCalculation"
                       :selected-quote-invoice="selectedQuoteInvoice"
                       @record-deleted="removeQuoteInvoiceFromList"
        ></quote-invoice>

    </div>
</template>

<script>

export default {

    props: ["title", "show", "modelId", "contactableId", "contactable", "ticketIssues"],

    data () {
        return {
            isIndeterminate: true,
            section: 0,
            quotesInvoices: [],
            companyChargesVat: false,
            autoCalculateVat: false,
            vatCalculation: "add vat",
            companyVatPercentage: .15,
            selectedQuoteInvoice: null,
            newRecordType: "invoice"
        };
    },

    created () {
        let self = this;

        Bus.$on("quote-invoice-updated", function (response) {
            let index = self.quotesInvoices.findIndex(qi => qi.id === response.id);
            // Remove the old quote from the array and insert the newly updated one
            self.quotesInvoices.splice(index, 1, response);
        });
    },

    mounted () {
        this.fetchQuotesAndInvoices();
    },

    methods: {
        createNew () {
            App.post("/tickets/" + this.contactableId + "/quotes-invoices/create", new AppForm({}))
            .then((response) => {
                this.quotesInvoices.unshift(response);
                this.showQuoteInvoiceForm(response);
            }).catch((errors) => {
                toastr.errors(errors);
            });
        },

        showQuoteInvoiceForm (item) {
            this.selectedQuoteInvoice = item;
            this.$refs.quoteInvoiceForm.showForm();
        },

        closeQuotesAndInvoicesPanel () {
            this.$emit("close-quotes-invoices-panel");
        },

        fetchQuotesAndInvoices () {
            axios.get("/tickets/" + this.contactableId + "/quotes-invoices/all")
            .then((response) => {
                this.quotesInvoices = response.data.quotes_invoices;
                this.companyChargesVat = response.data.company_charges_vat;
                this.companyVatPercentage = response.data.company_vat_percentage;
                this.vatCalculation = response.data.vat_calculation;
                this.autoCalculateVat = this.companyChargesVat && this.companyVatPercentage > 0;
            }).catch((errors) => {
                toastr.error("Could not fetch Quote & Invoice Records!");
            });
        },

        removeQuoteInvoiceFromList (quoteInvoiceId) {
            let index = this.quotesInvoices.findIndex(q => q.id === quoteInvoiceId);
            this.quotesInvoices.splice(index, 1);
        },
    },
};
</script>
